import React from 'react';
import { Avatar, Box } from '@mui/material';
import CustomTooltip from '../../../components/ToolTip/CustomToolTip';
import PropTypes from 'prop-types';

const getInitials = (name) => {
  if (!name) return 'U';
  const parts = name.trim().split(' ').filter(p => p.length > 0);
  return parts.map(p => p[0].toUpperCase()).join('');
};

const getAvatarColor = (status) => {
  if (status === 'PENDING') return '#dae6f7';
  if (status === 'WAITING') return '#F3F4F7';
  return '#DCFCE7';
};

const WorkflowAvatars = ({ values }) => {
  if (!values || !Array.isArray(values) || values.length === 0) {
    return null;
  }

  return (
    <Box display="flex" alignItems="center">
      {values.map((value, index) => (
        <React.Fragment key={`${value?.signer_id || value?.id || index}-${value?.status}`}>
          <CustomTooltip title={value?.signer_name} arrow>
            <Avatar
              sx={{
                width: 32,
                height: 32,
                fontSize: 14,
                bgcolor: getAvatarColor(value?.status),
                color: '#065F46',
                fontWeight: 500,
              }}
            >
              {getInitials(value?.signer_name)}
            </Avatar>
          </CustomTooltip>
          {index < values.length - 1 && (
            <Box
              sx={{
                width: '8px',
                height: '2px',
                backgroundColor: '#D1D5DB',
                marginLeft: '2px',
                marginRight: '2px',
              }}
            />
          )}
        </React.Fragment>
      ))}
    </Box>
  );
};

WorkflowAvatars.propTypes = {
  values: PropTypes.arrayOf(PropTypes.shape({
    signer_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    signer_name: PropTypes.string,
    status: PropTypes.string
  }))
};

export default WorkflowAvatars;
